import type {Pointer, PS, CompRef} from '@wix/document-services-types'
import _ from 'lodash'
import * as santaCoreUtils from '@wix/santa-core-utils'
import connections from '../../connections/connections'
import component from '../../component/component'
import dataModel from '../../dataModel/dataModel'
import platformAppComp from './utils/platformAppComp'
import appControllerUtils from '../../appControllerData/appControllerUtils'

function removeControllerConnections(ps: PS, controllerRef: Pointer) {
    const connectedComponents = connections.getConnectedComponentsForController(ps, controllerRef as CompRef, true)

    _.forEach(connectedComponents, function (comp) {
        connections.disconnect(ps, comp, controllerRef)
    })

    const mobileControllerRef = ps.pointers.structure.getMobilePointer(controllerRef)
    if (controllerRef.type === 'DESKTOP' && ps.dal.isExist(mobileControllerRef)) {
        removeControllerConnections(ps, mobileControllerRef)
    }
}

function handleControllerDeletion(ps: PS, controllerRef: Pointer) {
    removeControllerConnections(ps, controllerRef)
    platformAppComp.removePlatformApplicationFromPageIfLastController(ps, controllerRef)
    platformAppComp.removeControllerFromStateMap(ps, controllerRef)
}

function addRelatedConnections(ps: PS, controllerRef: Pointer, customStructureData) {
    const connectedComponents = connections.getConnectedComponents(ps, controllerRef)
    if (_.isEmpty(connectedComponents)) {
        return
    }
    const relatedConnections = _.transform(
        connectedComponents,
        function (acc, compRef) {
            acc[compRef.id] = _.filter(connections.get(ps, compRef), {controllerRef})
        },
        {}
    )
    _.set(customStructureData, 'relatedConnections', relatedConnections)
}

function handleControllerSerialization(ps: PS, controllerRef: Pointer, customStructureData) {
    addRelatedConnections(ps, controllerRef, customStructureData)
    platformAppComp.addControllerStateToSerializedStructure(ps, controllerRef, customStructureData)
}

function removeInvalidConnections(ps: PS, controllerRef: Pointer, newParentPointer: Pointer) {
    const newPageId = component.getPage(ps, newParentPointer as CompRef).id
    if (newPageId === santaCoreUtils.siteConstants.MASTER_PAGE_ID) {
        return
    }
    const connectedComponents = connections.getConnectedComponents(ps, controllerRef)
    _(connectedComponents)
        .reject(comp => component.getPage(ps, comp).id === newPageId)
        .forEach(comp => {
            connections.disconnect(ps, comp, controllerRef)
        })
}

function handleControllerParentChange(ps: PS, controllerRef: Pointer, newParentPointer: CompRef) {
    const dataItem = dataModel.getDataItem(ps, controllerRef)
    removeInvalidConnections(ps, controllerRef, newParentPointer)
    platformAppComp.removePlatformApplicationFromPageIfLastController(ps, controllerRef)
    platformAppComp.addPlatformAppToPageIfFirstController(
        ps,
        controllerRef,
        appControllerUtils.getControllerAppDefinitionId(dataItem),
        component.getPage(ps, newParentPointer)
    )
}

export default {
    //Before Remove
    handleControllerDeletion,
    //Custom Serialize
    handleControllerSerialization,
    //Change Parent
    handleControllerParentChange
}
